const compareByPOSInfo = (a, b) => {
  return (
    (a === null && b === null) || (a === undefined && b === undefined) || (a && b && a.id === b.id)
  )
}

export default compareByPOSInfo
